/* eslint-disable react/no-multi-comp, max-len */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const ERROR_CODES = {
    BATTLES_UNKNOWN_ERROR: 'UNKNOWN_ERROR',
    PRODUCTS_UNKNOWN_ERROR: 'PRODUCTS_UNKNOWN_ERROR',
    REWARDS_UNKNOWN_ERROR: 'REWARDS_UNKNOWN_ERROR',
    LEADERBOARDS_UNKNOWN_ERROR: 'LEADERBOARDS_UNKNOWN_ERROR',
}

export default {
    [ERROR_CODES.BATTLES_UNKNOWN_ERROR]: {
        title: (
            <FormattedMessage
                id='wgcwx_battle_schedule.battle_schedule_data_loading_error.title'
                defaultMessage='Не удалось отобразить список боёв'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_battle_schedule.battle_schedule_data_loading_error.description'
                defaultMessage='Список боёв временно недоступен. Попробуйте позже.'
            />
        ),
    },
    [ERROR_CODES.LEADERBOARDS_UNKNOWN_ERROR]: {
        title: (
            <FormattedMessage
                id='wgcwx_leaderboards.leaderboards_data_loading_error.title'
                defaultMessage='Не удалось отобразить достижения в событии'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_leaderboards.leaderboards_data_loading_error.description'
                defaultMessage='Достижения в событии временно недоступны. Попробуйте зайти на страницу позже.'
            />
        ),
    },
    [ERROR_CODES.REWARDS_UNKNOWN_ERROR]: {
        title: (
            <FormattedMessage
                id='wgcwx_shop_errors.titles.rewards_is_not_showed'
                defaultMessage='Не удалось отобразить список наград'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop_errors.rewards_purchase_is_not_available'
                defaultMessage='Получение наград временно недоступно. Попробуйте позже.'
            />
        ),
    },
    [ERROR_CODES.PRODUCTS_UNKNOWN_ERROR]: {
        title: (
            <FormattedMessage
                id='wgcwx_shop_errors.titles.products_is_not_showed'
                defaultMessage='Не удалось отобразить список бонусов'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_shop_errors.products_purchase_is_not_available'
                defaultMessage='Приобретение персональных бонусов временно недоступно. Попробуйте позже.'
            />
        ),
    },
}



// WEBPACK FOOTER //
// ./containers/WGCWXWrapper/errors.js